import { User } from '../user';
import { Sort } from '../sort.data';
import { PageRequest } from '../page-request.data';
import { CustomerLightData } from '../customer-light.data';
import { Partner } from '../partner';
import { Metric } from '../metric';
import { PartnerLightData } from '../partner-light-data';

export interface UserState {
  users: User[];
  pageRequest: PageRequest;
  loading: boolean;
  saving: boolean;
  metrics: Metric[];
  metricsLoading: boolean;
  customers: CustomerLightData[];
  partners: PartnerLightData[];
}

export const initialUserState: UserState = {
  users: [],
  pageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  loading: true,
  saving: false,
  metrics: [
    {
      label: 'users.totalUsers',
      value: 0,
      icon: 'people',
      iconSize: 1.375,
    },
    {
      label: 'users.activeUsers',
      value: 0,
      icon: 'sunny',
      iconSize: 1.375,
    },
    {
      label: 'users.inactiveUsers',
      value: 0,
      icon: 'bedtime',
      iconSize: 1.375,
    },
  ],
  metricsLoading: true,
  customers: [],
  partners: [],
};
